










































import Vue from 'vue'
import Component from 'vue-class-component'
import FormInput from '@/components/lib/input/FormInput.vue'
import SelectUserRoles from '@/components/select/userRoles/SelectUserRoles.vue'
import SelectStatus from '@/components/select/status/SelectStatus.vue'
import { EditEmployeeRequestModel} from '@/services/types'
import { StoreActionTypes } from '@/store/types'

const IEditCompanyEmployeeModalFromProps = Vue.extend({
    props: {
        disabled: Boolean,
        id: Number
    }
})

@Component({
    components: {
        FormInput,
        SelectUserRoles,
        SelectStatus
    }
})
export default class EditCompanyEmployeeModalForm extends IEditCompanyEmployeeModalFromProps {
    private componentClass = "EditCompanyEmployeeModalFrom"
    private firstname = ''
    private lastname = ''
    private surname = ''
    // private roleSelectValue: EmployeeRole = 'CONTROL'
    // private statusSelect: StatusType  = 'INACTIVE' 

    mounted() {
        if (this.id) {
            this.getEmployee()
        }
    }

    async getEmployee () {
        await this.$store.dispatch(StoreActionTypes.SET_EMPLOYEES_SELECTED_EMPLOYEE, this.id)

        const employee = this.$store.getters.getEmployeesSelectedEmployee
        this.firstname = employee.firstname
        this.surname = employee.surname
        this.lastname = employee.lastname
        // this.roleSelectValue = employee.role
        // this.statusSelect = employee.status
    }

    get dataIsReady() {
        return !!this.$store.getters.getEmployeesSelectedEmployee
    }

    firstnameChange(text: string) {
        this.firstname = text
    }

    surnameChange(text: string) {
        this.surname = text
    }

    lastnameChange(text: string) {
        this.lastname = text
    }

    // handleRoleSelectChangeEvent(selected: string) {
    //     this.roleSelectValue = selected as EmployeeRole
    // }

    // handleStatusSelectChangeEvent(selected: string) {
    //     this.statusSelect = selected as StatusType
    // }

    public getEditEmployeeRequestModel(): EditEmployeeRequestModel {
        return {
            firstname: this.firstname,
            surname: this.surname,
            lastname: this.lastname,
            // role: this.roleSelectValue,
            // status: this.statusSelect
        }
    } 

}
